import type { ReactNode } from 'react'
import React from 'react'
import { EmptyContent } from '../../EmptyContent'
import { Spinner } from '../../Spinner'

export type LoadingContentProps = {
  icon?: React.ReactNode
  iconComponent?: React.ReactNode
  message?: ReactNode
  subMessage?: ReactNode
}
export const LoadingContent = ({ icon, message, subMessage }: LoadingContentProps) => {
  message = message ?? 'Loading...'
  subMessage = subMessage ?? 'Please wait while we are loading your data...'
  icon = icon ?? <Spinner />

  return <EmptyContent icon={icon} message={message} subMessage={subMessage} />
}
